import { Box, Stack } from "@mui/material";
import styled from "styled-components";

export const Content = styled(Box)`
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  align-items: left;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 35px 35px 20px 35px;

  @media (min-width: 600px) {
    width: 464px;
  }
`;

export const ModalHeader = styled(Stack).attrs({
  direction: "row",
  justifyContent: "space-between",
  alignItems: "center",
})`
  margin-bottom: 26px;
`;

export const Title = styled.h1`
  font-size: 22px;
  line-height: 28px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Subtitle = styled.h3`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin-bottom: 20px;
  text-align: center;
`;

export const DeleteUserInformationContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`;

export const DeleteUserInformationText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;
